// libraries
import React, { useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Link, useHistory } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// assets
import navHome from "src/assets/images/home/side_home.svg";
import navNotification from "src/assets/images/home/side_notification.svg";
import navCrowd from "src/assets/images/home/side_user.svg";
import navAdd from "src/assets/images/home/side_add.svg";
import navPromote from "src/assets/images/home/side_promote.svg";
import navLogout from "src/assets/images/home/side_logout.svg";
import bottomImg from "src/assets/images/home/side_bottom.svg";

// context
import UserContext from "src/context/User";

// utils
import { logoutUser } from "src/utils/requests/logout";

// components
import TopSection from "./TopSection";

const Sidebar = ({ showSidebar, setShowSidebar }) => {
  const { user, logout, isLoading } = useContext(UserContext);

  const history = useHistory();

  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (showSidebar) setIsShow(showSidebar);
  }, [showSidebar]);

  const handleLogout = () => {
    logoutUser(user.accessToken, user.userId)
      .then((res) => {
        if (res.data.Status) {
          setShowSidebar(false);
          toast.success("Logout Successfully");
          logout();
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  return (
    <AnimatePresence>
      {isShow && (
        <motion.div
          // className={`${styles.sidebar} ${showSidebar ? styles.show : styles.hide}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={`${styles.sidebar}`}
          onClick={() => setShowSidebar(false)}
        >
          <AnimatePresence onExitComplete={() => setIsShow(false)}>
            {showSidebar && (
              <motion.div
                initial={{ x: -500 }}
                animate={{ x: 0 }}
                exit={{ x: -500 }}
                transition={{ type: "tween" }}
                className={styles.bar}
                onClick={(e) => e.stopPropagation()}
              >
                <div className={styles.top}>
                  <TopSection user={user} />
                </div>
                <div className={styles.mid}>
                  <ul>
                    <li onClick={() => history.push("/")}>
                      <img src={navHome} alt="nav-item" />
                      <p>Home</p>
                    </li>
                    <li>
                      <img src={navNotification} alt="nav-item" />
                      <p>Notification</p>
                    </li>
                    <li>
                      <img src={navCrowd} alt="nav-item" />
                      <p>My Crowd</p>
                    </li>
                    {!user ? (
                      <li onClick={() => history.push("/create-event")}>
                        <img src={navAdd} alt="nav-item" />
                        <p>Add Events</p>
                      </li>
                    ) : (
                      <li onClick={() => history.push("/myevents")}>
                        <img src={navAdd} alt="nav-item" />
                        <p>My Events</p>
                      </li>
                    )}
                    <li>
                      <img src={navPromote} alt="nav-item" />
                      <p>Promote My Event</p>
                    </li>
                    {user ? (
                      <li onClick={handleLogout}>
                        <img src={navLogout} alt="nav-item" />
                        <p>Logout</p>
                      </li>
                    ) : (
                      <li onClick={() => history.push("/login")}>
                        <img src={navLogout} alt="nav-item" />
                        <p>Login</p>
                      </li>
                    )}
                  </ul>
                </div>
                <div className={styles.bottom}>
                  <img src={bottomImg} alt="bottom" />
                  <div>
                    <h6>Become a Promoter</h6>
                    <p>Earn badges and reward</p>
                    <button>Get Started</button>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Sidebar;
